package com.techspiration.webuserapp.legal

import androidx.compose.runtime.Composable
import com.techspiration.webuserapp.site.SectionContainer
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

/**
 * Uygulama içi tek "Yasal" linkin (Auth/Settings/abonelik ekranı) hedefi — Gizlilik Politikası
 * ve Kullanım Şartları'na ayrı ayrı yönlendirir (Apple Guideline 3.1.2(c) her ikisini de ister).
 */
@Composable
fun LegalScreen() {
    SectionContainer {
        H1(attrs = { classes("t-h1") }) { Text("Yasal Bilgiler") }
        P(attrs = { classes("t-body") }) { Text("KamuApp (Atama Bildirim — Kamu İlanları) için yasal dokümanlar:") }
        Div {
            A(href = "/privacy", attrs = { classes("btn", "btn-ghost") }) { Text("Gizlilik Politikası") }
            A(href = "/terms", attrs = { classes("btn", "btn-ghost") }) { Text("Kullanım Şartları") }
        }
    }
}
